import React, { Fragment, useEffect } from 'react'
import EditBtn from '../../buttons/EditBtn'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import SpinnerLoading from '../../common/SpinnerLoading'
import { NoInfo } from '../../common/NoInfo'
import { mssgs } from '../../../constantes/mssgs'

const FinalProductsTable = ({
  handleRemove,
  toEditArticle,
  finalProducts,
  userProfile,
  loading,
}) => {
  useEffect(() => {}, [finalProducts])

  return (
    <>
      <div
        className='products__title__container mb-30'
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <h3 className='products__title'>Productos finales</h3>
        <span className='products__title__count-results'>{finalProducts?.length} resultados.</span>
      </div>
      <Fragment>
        <div className='table-wrapper'>
          <table className='products-table'>
            <thead>
              <tr>
                <th className="table-th-code">
                  Referencia
                </th>
                <th>
                  Nombre
                </th>
                <th>
                  Categoría producto
                </th>
                <th>
                  Família del producto
                </th>
                <th className="table-th-doccount">
                  Port.
                </th>
                <th className="table-th-doccount">
                  Imgs.
                </th>
                <th className="table-th-doccount">
                  Docs.
                </th>
                <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                    Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {finalProducts.length > 0 ? (
                finalProducts.map((product, i) => (
                  <tr key={i}>
                    <td>
                      {product.referencia}
                    </td>
                    <td className="table-td-header">
                      {product.nombre}
                    </td>
                    <td>
                      {product.nombreCategoria}
                    </td>
                    <td>
                      {product.nombrePadreProducto !== ''
                        ? product.nombrePadreProducto
                        : NoInfo('Sin Família')}
                    </td>
                    <td
                      className="table-td-doccount"
                      title={product?.cover ? `Portada:\n\n\t${product?.cover}\n.` : undefined}
                    >
                        {product.coverCount > 0 ? product.coverCount : ''}
                    </td>
                    <td
                      className="table-td-doccount"
                      title={product?.images?.length > 0 ? `Documentos:\n\n ${product?.images?.map((img) => "\t * " + img).join('\n')}\n.` : undefined}
                    >
                        {product.imageCount > 0 ? product.imageCount : ''}
                    </td>
                    <td
                      className="table-td-doccount"
                      title={product?.documents?.length > 0 ? `Documentos:\n\n ${product?.documents?.map((doc) => "\t * " + doc).join('\n')}\n.` : undefined}
                    >
                        {product.documentCount > 0 ? product.documentCount : ''}
                    </td>
                    <td className="table-td-actions">
                          <button
                            onClick={() => toEditArticle(product.id_Articulo)}
                          >
                            <EditBtn />
                          </button>
                          <button
                            onClick={() => handleRemove(product.id_Articulo)}
                          >
                            <DeleteBtn />
                          </button>
                    </td>
                  </tr>
                ))
              ) : (
                <td colSpan={5}>
                  {loading ? (
                    <SpinnerLoading
                      loading={loading}
                      size={60}
                      color='#0ca39d'
                    />
                  ) : (
                    <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_PRODUCTOS} />
                  )}
                </td>
              )}
            </tbody>
          </table>
        </div>
      </Fragment>
    </>
  )
}

export default FinalProductsTable
